var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8PrivacyPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.476,
    height: 16,
    viewBox: "0 0 14.476 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-privacy-policy",
    d: "M9.714,4A1.707,1.707,0,0,0,8,5.714v11.81a1.707,1.707,0,0,0,1.714,1.714h6.629A4.44,4.44,0,0,1,15.5,18.1H9.714a.586.586,0,0,1-.571-.571V5.714a.586.586,0,0,1,.571-.571H14.1V8.381A1.707,1.707,0,0,0,15.81,10.1h3.238v.381a1.086,1.086,0,0,1,.914.457c.076.076.152.191.228.267V9.524a.571.571,0,0,0-.171-.4l0,0L15.071,4.167l0,0a.571.571,0,0,0-.4-.171Zm5.524,1.951,3,3H15.81a.586.586,0,0,1-.571-.571Zm3.81,5.3a.389.389,0,0,0-.305.143A3.869,3.869,0,0,1,16,12.762a.36.36,0,0,0-.381.381v2.286A4.644,4.644,0,0,0,18.972,20h.152a4.693,4.693,0,0,0,3.353-4.571V13.143a.41.41,0,0,0-.381-.381,3.869,3.869,0,0,1-2.743-1.371A.389.389,0,0,0,19.048,11.248ZM11.619,12a.571.571,0,1,0,0,1.143h3.238A1.127,1.127,0,0,1,15.885,12Zm0,2.667a.571.571,0,1,0,0,1.143h3.238V14.667Z",
    transform: "translate(-8 -4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8PrivacyPolicy);
export default __webpack_public_path__ + "static/media/icons8-privacy-policy.06fa44a1744228894146c72eb7950d55.svg";
export { ForwardRef as ReactComponent };